import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class QuestionService {  

  async getQuestionById(questionId: string) {
      return await Api().get(`${API_URL}/question/${questionId}`, { headers:  authHeader() as any });      
  }

  async findQuestions(term: string, onlyAdHocParentQuestions: boolean, adHocParentQuestionsIds: string) {   
    if (onlyAdHocParentQuestions === undefined) {
      onlyAdHocParentQuestions = false;
    }
	return await Api().get(`${API_URL}/question/find?text=${term}%&maxResults=-1&onlyAdHocParentQuestions=${onlyAdHocParentQuestions}&adHocParentQuestionsIds=${adHocParentQuestionsIds}`, { headers:  authHeader() as any });      
  }

  async findQuestionsPaged(term: string, onlyAdHocParentQuestions: boolean, adHocParentQuestionsIds: string, page: number, shouldIncludeArchived: boolean, questionCategories: number[], onlyFolderQuestions: boolean, folderId: number, signal?: AbortSignal) {    
    var folderIdQuery = "";
    if (onlyAdHocParentQuestions === undefined) {
      onlyAdHocParentQuestions = false;
    }
    if (shouldIncludeArchived === undefined) {
      shouldIncludeArchived = false;
    }
    if (questionCategories === undefined || questionCategories === null) {
      questionCategories = [];
    }
    if (folderId !== undefined && folderId !== null && folderId > 0) {
      folderIdQuery = "&folderId=" + folderId;
    }

    const questionSearch = {
      text: term,
      maxResults: -1,
      onlyAdHocParentQuestions,
      adHocParentQuestionsIds,
      page,
      questionCategories,
      shouldIncludeArchived,
      OnlyFolderQuestions: onlyFolderQuestions,
      folderId: folderId !== undefined && folderId !== null && folderId > 0 ? folderId : null
    };

    return await Api().post(`${API_URL}/question/findPaged`, questionSearch, { method: 'POST', headers:  authHeader() as any, signal });      
  }

  async UpdateQuestion(question: any) {
    return await Api().put(`${API_URL}/question/${question.id}`, question, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async ArchiveQuestion(questionId: string, archive: number) {    
    
    return await Api().put(`${API_URL}/question/Archive/${questionId}?archiveQuestion=${archive}`, archive, 
    { method: 'PUT',
      headers:  authHeader() as any 
    });      
  }  

  async CreateQuestion(question: any) {
    return await Api().post(`${API_URL}/question/`, question, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async DeleteQuestion(question: any) {
    return await Api().delete(`${API_URL}/question/${question.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }

  async UploadVideoToQuestion(questionId: string, optionValue: number, video: any) {
	const formData = new FormData();
  formData.append('targetEntity', "question");   
  if (questionId ?? "") {
	  formData.append('targetEntityId', questionId);
  }
	formData.append('answerOption', optionValue ? optionValue.toString() : "");
	formData.append('file', video);

    return await Api().post(`${API_URL}/mediamanager/UploadVideo`, formData, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async UploadImageToQuestion(questionId: string, optionValue: number, image: any) {
	const formData = new FormData();
  formData.append('targetEntity', "question");
  if (questionId ?? "") {
	  formData.append('targetEntityId', questionId);
  }
	formData.append('answerOption', optionValue ? optionValue.toString() : "");
	formData.append('file', image);

    return await Api().post(`${API_URL}/mediamanager/UploadImage`, formData, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async DeleteImageFromQuestion(deleteRequest: any) {
    return await Api().delete(`${API_URL}/mediamanager/DeleteImage`, 
    { method: 'DELETE',
      headers:  authHeader() as any,
      data: deleteRequest });      
  }

  async DeleteVideoFromQuestion(deleteRequest: any) {
    return await Api().delete(`${API_URL}/mediamanager/DeleteVideo`, 
    { method: 'DELETE',
      headers:  authHeader() as any,
     data: deleteRequest });      
  }
}

export default new QuestionService();